import React, {useContext, useEffect, useRef, useState} from "react";
import {
  Box,
  Button,
  Checkbox, Divider,
  Fade,
  FormControlLabel,
  Grid,
  Stack,
  TextField, Toolbar,
  Typography
} from "@mui/material";
import {Link} from "react-router-dom";
import {grey} from "@mui/material/colors";
import {ArrowForwardIos} from "@mui/icons-material";
import {toast} from "react-toastify";
import {SignInContext} from "../../../context/SignInContext";
import {IconBrandGoogle} from "@tabler/icons-react";

export const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const {onForgotPassword} = useContext(SignInContext);

  const loginHandle = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error("Please enter email address");
      return;
    }
    const toastId = toast.loading("Sending request for forgot password")
    try {
      await onForgotPassword({email});
      toast.update(toastId, {
        type: "success", render: `Please check your email address`, isLoading: false, autoClose: 2000
      });
      setEmail("");
    } catch (err) {
      toast.update(toastId, {
        type: "error", render: err?.message || `Please try again later.`, isLoading: false, autoClose: 2000
      });
    }
  }

  return (
    <Grid container sx={{width: "100%", height: "100%", bgcolor: "rgb(255,255,255)"}}>
      <Grid item gap={2} xs={12} justifyContent={"space-between"} className={"bg-primary-gradient"} sx={{display: "flex", flexDirection: "column", height: "100%"}}>
        <Toolbar>
          <img src={"/logo.svg"} alt={"logo"} width={30}/>
        </Toolbar>
        <Stack
          maxWidth={"sm"} direction={"column"} gap={3}
          sx={{maxWidth: "400px", width: "100%", px: 3, py: 5, borderRadius: 4, bgcolor: "#fefefe", mx: "auto"}}
          justifyContent={'center'} alignItems={"center"}
        >
          {/*HEADER*/}
          <Stack direction={"column"} gap={2} sx={{width: '100%'}}>
            {/*TITLE*/}
            <Typography color={"dark.main"} fontSize={40} variant={'h3'} textAlign={"center"}
                        fontWeight={"bold"}>Forgot Password</Typography>
            {/*SIGN UP*/}

            <Box sx={{textAlign: "center"}}>
              <Typography sx={{color: grey[700]}} component={"span"}>Already have an account?</Typography>
              <Link to={"/login"} style={{
                paddingLeft: 5,
                color: "#252525",
                fontWeight: 'bold',
                textDecoration: "none",
                cursor: "pointer"
              }}>
                Sign in
              </Link>
            </Box>
          </Stack>
          {/*LOGIN WITH MAIL*/}
          <Stack component={"form"} onSubmit={loginHandle} direction={"column"} gap={2} sx={{width: '100%'}}>
            <Box>
              <Typography fontWeight={600} gutterBottom>Email address</Typography>
              <TextField
                variant={"outlined"}
                required
                fullWidth
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder={"johndoe@mail.com"}
              />
            </Box>
            <Button
              fullWidth
              type={"submit"}
              variant={"modal"}
              sx={{
                textTransform: "capitalize",
                fontWeight: "bold",
                borderRadius: "8px !important"
              }}
              endIcon={<ArrowForwardIos style={{fontSize: 13}}/>}
            >
              Continue
            </Button>

          </Stack>
        </Stack>
        <Toolbar sx={{justifyContent: "space-between"}}>
          <img src={"/logo-black.svg"} alt={"logo"} width={60}/>
          <a href={"https://openbrain.io"} target={"_self"}
             style={{fontSize: 12, textDecoration: "none", color: "#252525"}}>openbrain.io</a>
        </Toolbar>
      </Grid>

    </Grid>
  )
}